var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1037.22487,
    height: 575.51236,
    viewBox: "0 0 1037.22487 575.51236",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 882.15369,
    cy: 68.01825,
    r: 63,
    fill: "#ff6884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.21204,461.51721l-71.05322-4.5293-3.83154-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l76.12061-76.12061c10.65576-10.65479,27.42725-11.4248,39.01318-1.78662l82.60742,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61427l-2.83838,240.28076,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00684-11.53809Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.15351,114.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h20.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.15351,229.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h30.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-30.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.81018,358.23691c-3.72461-.13184-6.72803-3.1543-6.83838-6.87988l-1.55811-52.98145c-.06641-2.26172,.9126-4.36328,2.68604-5.76855,1.77344-1.4043,4.04443-1.87305,6.23096-1.29297l1.55811,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.1665,5.10254-1.33496,1.28906-3.07275,1.98926-4.91846,1.98926-.08594,0-.17188-.00098-.2583-.00391Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.15351,350.92639v-54.97461c0-3.88086,3.03955-6.99512,6.91943-7.09082l28.0083-.68262c3.88232-.05371,7.14893,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08643,2.15039h-29.62207c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.70124,388.49167l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.22654,
    y: 459.33348,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-6.2006 12.56321) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.59775,
    y: 450.28473,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-3.49374 7.14922) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.02763,
    y: 441.63315,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-8.46002 17.88065) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.58126,
    y: 433.06324,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-13.88619 30.45777) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.01403,
    y: 425.09485,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-14.39199 32.19464) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.58228,
    y: 417.01858,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 875.21524,
    y: 410.33205,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.75205 10.61455) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.95235,
    y: 403.91481,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-12.92403 30.13257) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.64896,
    y: 396.51848,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-6.83881 15.87313) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.93432,
    y: 389.92555,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-11.75728 28.20181) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.40233,
    y: 383.26857,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.70488 8.75837) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.65351,362.42639v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.21204,461.51721l-58.09033-3.7002-.46826-.03027v-44.95703c0-5.68555,4.62549-10.31152,10.31104-10.31152h57.37793c5.68555,0,10.31104,4.62598,10.31104,10.31152v48.68848h-.5l-18.94141-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.65351,239.42638v-51.81592c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81592c0,3.91016-3.18115,7.0918-7.0918,7.0918h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.65369,466.51825l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.21109,445.51721l-71.05176-4.5293-3.83203-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l76.12109-76.12062c10.65527-10.65625,27.42676-11.42432,39.0127-1.78662l82.60739,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61426l-2.83838,240.28078,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00781-11.53809h.00003Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.15348,98.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.15348,213.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.31949,340.25156c-1.39648-1.34863-2.16602-3.16113-2.16602-5.10254v-52.56641c0-3.20801,2.16504-6.02539,5.26465-6.85254l1.55859-.41602c2.18359-.58008,4.45703-.11133,6.23047,1.29297,1.77441,1.40527,2.75293,3.50781,2.68652,5.76855l-1.55859,52.98145c-.10938,3.72559-3.1123,6.74805-6.83789,6.87988-.08594,.00293-.17285,.00391-.25879,.00391-1.84473,0-3.58301-.70117-4.91895-1.98926Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.15348,334.92639v-54.97461c0-3.88086,3.03906-6.99512,6.91992-7.09082l28.00781-.68262c.05957-.00098,.11719-.00195,.17578-.00195,3.81348,0,6.97559,3.05371,7.08691,6.88672l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08691,2.15039h-29.62109c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.70124,372.49167l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.22654,
    y: 443.33348,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-6.00514 9.15775) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.59775,
    y: 434.28471,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-3.37635 5.2035) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.02763,
    y: 425.63317,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-8.19506 13.01523) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.58125,
    y: 417.06325,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-13.49237 22.18593) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.01402,
    y: 409.09487,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-13.98358 23.43624) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.58228,
    y: 401.01858,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.21524,
    y: 394.33203,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.58166 7.6957) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.95235,
    y: 387.9148,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-12.53022 21.86073) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.64895,
    y: 380.51849,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-6.59607 11.49437) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.93433,
    y: 373.92554,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-11.37902 20.41656) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.40233,
    y: 367.26856,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.56051 6.32609) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.65351,346.42639v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.21109,445.51721l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.65351,223.42589v-51.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.65369,450.51825l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.21109,429.51721l-71.05176-4.5293-3.83203-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301L300.9318,8.53331c10.65527-10.65576,27.42773-11.42383,39.01172-1.78662l82.6084,68.71826c6.73926,5.60596,10.54492,13.84863,10.44141,22.61426l-2.83789,240.28078,35.9043,49.86621,.0752,.10547,6.08398,52.72363-181.00781-11.53809Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.15348,82.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.15348,197.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.54735,260.21329l1.55829-.41556c4.26292-1.13678,8.41766,2.15347,8.28796,6.56345l-1.55827,52.98154c-.10216,3.47351-2.88312,6.27124-6.35596,6.39429h-.00002c-3.72997,.13217-6.82567-2.8558-6.82567-6.5881v-52.56601c0-2.98663,2.00789-5.6001,4.89366-6.36966v.00006Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.15348,318.92639v-54.97461c0-3.88086,3.03906-6.99512,6.91992-7.09082l28.00781-.68262c3.90234-.0625,7.14941,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08691,2.15039h-29.62109c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.70124,356.49167l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.22655,
    y: 427.33347,
    width: 71.25528,
    height: 1.00009,
    transform: "translate(-5.80968 5.75228) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.59778,
    y: 418.28469,
    width: 67.55679,
    height: 1.00003,
    transform: "translate(-3.25895 3.25778) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.02759,
    y: 409.63319,
    width: 64.63181,
    height: 1.00018,
    transform: "translate(-7.9301 8.14981) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.58128,
    y: 401.06324,
    width: 62.08988,
    height: 1.00055,
    transform: "translate(-13.09856 13.9141) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.01402,
    y: 393.09489,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-13.57516 14.67784) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.58225,
    y: 385.01858,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.21525,
    y: 378.33202,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.41127 4.77685) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.95234,
    y: 371.91481,
    width: 54.71591,
    height: 1.00055,
    transform: "translate(-12.1364 13.5889) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.64891,
    y: 364.51849,
    width: 54.00925,
    height: 1.00015,
    transform: "translate(-6.35332 7.11562) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.93436,
    y: 357.92554,
    width: 51.73135,
    height: 1.00049,
    transform: "translate(-11.00075 12.6313) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.4023,
    y: 351.26856,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.41614 3.89381) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.65348,330.42639v-67.81543c0-3.91113,3.18164-7.09277,7.09277-7.09277h32.81543c3.91016,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18164,7.0918-7.0918,7.0918h-32.81543c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.21109,429.51721l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.65348,207.42589v-51.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h10.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v51.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-10.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.65369,434.51825l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24513,4.90265,8.99998,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.22047,
    y: -7.3531,
    width: 2.00024,
    height: 911.775,
    transform: "translate(97.09733 1000.63887) rotate(-86.30501)",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M661.99572,558.11742l-71.05322-4.5293-3.83154-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l76.12061-76.12061c10.65576-10.65479,27.42725-11.4248,39.01318-1.78662l82.60742,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61427l-2.83838,240.28076,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00684-11.53809Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.93719,211.5261v-14.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h20.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.93719,326.5261v-54.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h30.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-30.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.59387,454.83712c-3.72461-.13184-6.72803-3.1543-6.83838-6.87988l-1.55811-52.98145c-.06641-2.26172,.9126-4.36328,2.68604-5.76855,1.77344-1.4043,4.04443-1.87305,6.23096-1.29297l1.55811,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.1665,5.10254-1.33496,1.28906-3.07275,1.98926-4.91846,1.98926-.08594,0-.17188-.00098-.2583-.00391Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.93719,447.5266v-54.97461c0-3.88086,3.03955-6.99512,6.91943-7.09082l28.0083-.68262c3.88232-.05371,7.14893,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08643,2.15039h-29.62207c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.48492,485.09188l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 753.01023,
    y: 555.93369,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-7.53307 10.83312) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.38144,
    y: 546.88494,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-4.25228 6.15833) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.81131,
    y: 538.23336,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-10.37065 15.41485) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.36495,
    y: 529.66345,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-17.16192 26.28932) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.79771,
    y: 521.69506,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-17.86455 27.78458) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.36596,
    y: 513.61879,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 747.99893,
    y: 506.93226,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-5.89273 9.13047) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 746.73603,
    y: 500.51502,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-16.19976 25.96412) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.43264,
    y: 493.11869,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-8.55625 13.65216) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 743.71801,
    y: 486.52576,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-14.83663 24.27538) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 742.18602,
    y: 479.86878,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-4.65426 7.5207) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.43719,459.0266v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.99572,558.11742l-58.09033-3.7002-.46826-.03027v-44.95703c0-5.68555,4.62549-10.31152,10.31104-10.31152h57.37793c5.68555,0,10.31104,4.62598,10.31104,10.31152v48.68848h-.5l-18.94141-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.43719,336.02659v-51.81592c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81592c0,3.91016-3.18115,7.0918-7.0918,7.0918h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.43738,563.11846l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.99478,542.11742l-71.05176-4.5293-3.83203-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l76.12109-76.12062c10.65527-10.65625,27.42676-11.42432,39.0127-1.78662l82.60739,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61426l-2.83838,240.28078,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00781-11.53809h.00003Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93716,195.5261v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93716,310.5261v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.10318,436.85177c-1.39648-1.34863-2.16602-3.16113-2.16602-5.10254v-52.56641c0-3.20801,2.16504-6.02539,5.26465-6.85254l1.55859-.41602c2.18359-.58008,4.45703-.11133,6.23047,1.29297,1.77441,1.40527,2.75293,3.50781,2.68652,5.76855l-1.55859,52.98145c-.10938,3.72559-3.1123,6.74805-6.83789,6.87988-.08594,.00293-.17285,.00391-.25879,.00391-1.84473,0-3.58301-.70117-4.91895-1.98926Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.93716,431.5266v-54.97461c0-3.88086,3.03906-6.99512,6.91992-7.09082l28.00781-.68262c.05957-.00098,.11719-.00195,.17578-.00195,3.81348,0,6.97559,3.05371,7.08691,6.88672l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08691,2.15039h-29.62109c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.48492,469.09188l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.01023,
    y: 539.93369,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-7.33761 7.42766) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.38144,
    y: 530.88492,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-4.13489 4.21261) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.81131,
    y: 522.23338,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-10.10569 10.54942) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.36493,
    y: 513.66346,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-16.7681 18.01749) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.79771,
    y: 505.69508,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-17.45613 19.02619) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.36596,
    y: 497.61879,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.99893,
    y: 490.93224,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-5.72234 6.21162) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.73603,
    y: 484.51501,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-15.80595 17.69229) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.43263,
    y: 477.1187,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-8.31351 9.27341) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.71801,
    y: 470.52575,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-14.45837 16.49012) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.18602,
    y: 463.86877,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-4.50989 5.08841) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.43719,443.0266v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.99478,542.11742l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.43719,320.0261v-51.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.43738,547.11846l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.99478,526.11742l-71.05176-4.5293-3.83203-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l76.12109-76.12062c10.65527-10.65576,27.42773-11.42383,39.01172-1.78662l82.6084,68.71826c6.73926,5.60596,10.54492,13.84863,10.44141,22.61426l-2.83789,240.28078,35.9043,49.86621,.0752,.10547,6.08398,52.72363-181.00781-11.53809Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93716,179.5261v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.93716,294.5261v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33104,356.8135l1.55829-.41556c4.26292-1.13678,8.41766,2.15347,8.28796,6.56345l-1.55827,52.98154c-.10216,3.47351-2.88312,6.27124-6.35596,6.39429h-.00002c-3.72997,.13217-6.82567-2.8558-6.82567-6.5881v-52.56601c0-2.98663,2.00789-5.6001,4.89366-6.36966v.00006Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.93716,415.5266v-54.97461c0-3.88086,3.03906-6.99512,6.91992-7.09082l28.00781-.68262c3.90234-.0625,7.14941,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08691,2.15039h-29.62109c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.48492,453.09188l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.01023,
    y: 523.93368,
    width: 71.25528,
    height: 1.00009,
    transform: "translate(-7.14215 4.02219) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.38146,
    y: 514.8849,
    width: 67.55679,
    height: 1.00003,
    transform: "translate(-4.01749 2.26689) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.81128,
    y: 506.2334,
    width: 64.63181,
    height: 1.00018,
    transform: "translate(-9.84073 5.684) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.36496,
    y: 497.66345,
    width: 62.08988,
    height: 1.00055,
    transform: "translate(-16.37429 9.74565) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.7977,
    y: 489.6951,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-17.04771 10.26779) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.36593,
    y: 481.61879,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.99893,
    y: 474.93223,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-5.55195 3.29278) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.73602,
    y: 468.51502,
    width: 54.71591,
    height: 1.00055,
    transform: "translate(-15.41213 9.42045) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.4326,
    y: 461.1187,
    width: 54.00925,
    height: 1.00015,
    transform: "translate(-8.07076 4.89465) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.71804,
    y: 454.52575,
    width: 51.73135,
    height: 1.00049,
    transform: "translate(-14.08011 8.70487) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.18599,
    y: 447.86877,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-4.36552 2.65613) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43716,427.0266v-67.81543c0-3.91113,3.18164-7.09277,7.09277-7.09277h32.81543c3.91016,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18164,7.0918-7.0918,7.0918h-32.81543c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#232c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.99478,526.11742l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43716,304.0261v-51.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h10.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v51.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-10.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43738,531.11846l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24513,4.90265,8.99998,42,3,44",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.00416,
    y: 89.24711,
    width: 2.00024,
    height: 911.775,
    transform: "translate(-118.31992 964.0618) rotate(-86.30501)",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTown);
export default __webpack_public_path__ + "static/media/town.2b700392a413673ebc3f32cc2f1aec1e.svg";
export { ForwardRef as ReactComponent };